import { type InsuranceCorporateIdentity } from "../types";

export function SudzuckerBkkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_36_10189)">
        <mask
          id="mask0_36_10189"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="32"
          y="225"
          width="449"
          height="65"
        >
          <path d="M32.9995 290H481V225H32.9995V290Z" fill="white" />
        </mask>
        <g mask="url(#mask0_36_10189)">
          <path
            d="M75.5479 244.349C73.9178 241.99 71.2559 240.457 67.6163 240.457C63.8142 240.457 59.4138 242.758 59.4138 247.749C59.4138 252.682 63.4868 253.944 67.7789 255.369C73.2134 257.178 79.1875 258.932 79.1875 266.719C79.1875 274.505 72.7234 277.905 66.6387 277.905C61.9673 277.905 57.2937 275.986 54.5234 272.147L57.892 269.626C59.5764 272.365 62.674 274.505 66.6929 274.505C70.6598 274.505 75.2228 271.983 75.2228 266.994C75.2228 261.564 70.714 260.195 65.8236 258.659C60.7188 257.068 55.5033 254.822 55.5033 247.803C55.5033 240.29 62.1299 237.112 67.7789 237.112C72.9402 237.112 76.7965 239.304 78.6456 241.826L75.5479 244.349Z"
            fill="#1478C7"
          />
          <path
            d="M105.914 227.68C107.544 227.68 108.684 229.052 108.684 230.476C108.684 231.903 107.544 233.272 105.914 233.272C104.284 233.272 103.144 231.903 103.144 230.476C103.144 229.052 104.284 227.68 105.914 227.68ZM95.4831 227.68C97.1132 227.68 98.2557 229.052 98.2557 230.476C98.2557 231.903 97.1132 233.272 95.4831 233.272C93.853 233.272 92.7128 231.903 92.7128 230.476C92.7128 229.052 93.853 227.68 95.4831 227.68ZM86.2488 262.442V238.099H90.1593V262.002C90.1593 268.255 92.8212 274.396 100.644 274.396C108.468 274.396 111.13 268.255 111.13 262.002V238.099H115.042V262.442C115.042 268.914 112.161 277.903 100.644 277.903C89.1275 277.903 86.2488 268.914 86.2488 262.442Z"
            fill="#1478C7"
          />
          <path
            d="M126.772 273.408H134.541C146.112 273.408 151.709 265.513 151.709 257.508C151.709 249.503 146.112 241.607 134.541 241.607H126.772V273.408ZM122.859 238.098H135.627C145.243 238.098 155.837 244.567 155.837 257.508C155.837 270.448 145.243 276.918 135.627 276.918H122.859V238.098Z"
            fill="#1478C7"
          />
          <path
            d="M187.288 241.388L164.85 273.408H187.613V276.917H159.906V273.629L182.398 241.606H160.506V238.097H187.288V241.388Z"
            fill="#1478C7"
          />
          <path
            d="M195.271 262.442V238.099H199.181V262.002C199.181 268.255 201.843 274.396 209.667 274.396C217.49 274.396 220.152 268.255 220.152 262.002V238.099H224.064V262.442C224.064 268.911 221.184 277.903 209.667 277.903C198.15 277.903 195.271 268.911 195.271 262.442Z"
            fill="#1478C7"
          />
          <path
            d="M266.434 270.667C263.88 274.559 258.936 277.904 252.036 277.904C240.413 277.904 231.991 269.295 231.991 257.508C231.991 245.72 240.576 237.111 252.036 237.111C257.687 237.111 263.065 239.469 265.727 243.252L262.467 245.665C260.839 243.143 256.983 240.565 252.092 240.565C242.151 240.565 236.121 248.461 236.121 257.508C236.121 266.554 242.206 274.45 252.092 274.45C256.493 274.45 260.729 272.695 263.39 268.692L266.434 270.667Z"
            fill="#1478C7"
          />
          <path
            d="M277.078 255.534H277.132L295.44 238.097H301.035L281.641 255.698L302.123 276.917H296.364L277.132 256.247H277.078V276.917H273.167V238.097H277.078V255.534Z"
            fill="#1478C7"
          />
          <path
            d="M312.278 273.408H332.866V276.918H308.367V238.098H332.214V241.607H312.278V254.985H330.911V258.44H312.278V273.408Z"
            fill="#1478C7"
          />
          <path
            d="M344.436 255.369H351.227C357.474 255.369 361.06 253.066 361.06 248.46C361.06 243.361 357.203 241.497 351.39 241.497H344.436V255.369ZM344.436 276.917H340.525V238.097H351.825C359.43 238.097 364.97 240.895 364.97 248.46C364.97 254.219 360.732 257.837 355.138 258.439L366.384 276.917H361.604L350.956 258.769H344.436V276.917Z"
            fill="#1478C7"
          />
          <path
            d="M388.383 273.517H395.662C401.311 273.517 406.256 271.38 406.256 265.952C406.256 260.852 402.616 258.33 396.369 258.33H388.383V273.517ZM388.383 255.094H396.26C400.008 255.094 404.409 253.451 404.409 248.297C404.409 243.361 400.227 241.497 395.174 241.497H388.383V255.094ZM384.47 238.097H395.935C401.801 238.097 408.319 240.237 408.319 248.023C408.319 252.079 405.603 255.424 401.53 256.356V256.466C406.526 257.015 410.222 260.524 410.222 266.171C410.222 272.64 404.734 276.917 395.879 276.917H384.47V238.097Z"
            fill="#ED192D"
          />
          <path
            d="M420.757 255.534H420.811L439.12 238.097H444.714L425.32 255.698L445.8 276.917H440.043L420.811 256.247H420.757V276.917H416.847V238.097H420.757V255.534Z"
            fill="#ED192D"
          />
          <path
            d="M455.957 255.534H456.011L474.32 238.097H479.914L460.52 255.698L481 276.917H475.243L456.011 256.247H455.957V276.917H452.044V238.097H455.957V255.534Z"
            fill="#ED192D"
          />
          <path d="M34.9734 223.528V291.473Z" fill="#1478C7" />
          <path
            d="M34.9734 223.528V291.473"
            stroke="#1478C7"
            stroke-width="6.29288"
            stroke-miterlimit="10"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_36_10189">
          <rect
            width="448"
            height="65"
            fill="white"
            transform="translate(33 225)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const SudzuckerBkk: InsuranceCorporateIdentity = {
  id: "sudzucker-bkk",
  name: "Südzucker BKK",
  logo: SudzuckerBkkLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: { or: ["suedzucker", "sudzucker", "südzucker"] },
  type: "statutory",
};
